import React, { useState, useEffect } from 'react';
import { client } from '../utils/api';
import DataTable from '../components/DataTable';

const CONTROLLER = 'eventsController.php';

const columns = [
  { key: 'id', label: 'ID' },
  { key: 'title', label: 'Title' },
  { key: 'startTime', label: 'Start Time' },
  { key: 'location', label: 'Location' },
  { key: 'price', label: 'Price' },
];

const initialFormState = {
  title: '',
  startTime: '',
  endTime: '',
  location: '',
  description: '',
  price: '',
  capacity: '',
};

export default function EventsManager() {
  const [events, setEvents] = useState([]);
  const [form, setForm] = useState(initialFormState);
  const [editingId, setEditingId] = useState(null);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    loadEvents();
  }, []);

  const loadEvents = async () => {
    try {
      const res = await client.get(CONTROLLER);
      setEvents(res.events || []);
    } catch (err) {
      setError('Failed to fetch events: ' + err.message);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    try {
      if (editingId) {
        await client.put(CONTROLLER, editingId, form);
        setSuccess('Event updated successfully.');
      } else {
        await client.post(CONTROLLER, form);
        setSuccess('Event created successfully.');
      }

      setForm(initialFormState);
      setEditingId(null);
      await loadEvents();
    } catch (err) {
      setError(err.message);
    }
  };

  const handleEdit = (eventItem) => {
    setEditingId(eventItem.id);
    setForm({
      title: eventItem.title || '',
      startTime: eventItem.startTime || '',
      endTime: eventItem.endTime || '',
      location: eventItem.location || '',
      description: eventItem.description || '',
      price: eventItem.price || '',
      capacity: eventItem.capacity || '',
    });
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this event?')) {
      return;
    }

    try {
      setError('');
      await client.delete(CONTROLLER, id);
      setSuccess('Event deleted successfully.');
      await loadEvents();
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="admin-view-wrapper">
      <div className="admin-view-header">
        <h2 className="admin-title">Event Management</h2>
        {error && <div className="admin-error">{error}</div>}
        {success && <div className="admin-success">{success}</div>}
      </div>

      <form onSubmit={handleSubmit} className="admin-form-container grid-2-col">
        <div className="form-group">
          <label>Title *</label>
          <input
            type="text"
            placeholder="e.g. Networking Evening"
            required
            value={form.title}
            onChange={(e) => setForm({ ...form, title: e.target.value })}
          />
        </div>

        <div className="form-group">
          <label>Location</label>
          <input
            type="text"
            placeholder="e.g. Lausanne"
            value={form.location}
            onChange={(e) => setForm({ ...form, location: e.target.value })}
          />
        </div>

        <div className="form-group">
          <label>Start Time *</label>
          <input
            type="datetime-local"
            required
            value={form.startTime}
            onChange={(e) => setForm({ ...form, startTime: e.target.value })}
          />
        </div>

        <div className="form-group">
          <label>End Time</label>
          <input
            type="datetime-local"
            value={form.endTime}
            onChange={(e) => setForm({ ...form, endTime: e.target.value })}
          />
        </div>

        <div className="form-group">
          <label>Price</label>
          <input
            type="text"
            placeholder="e.g. 50 CHF"
            value={form.price}
            onChange={(e) => setForm({ ...form, price: e.target.value })}
          />
        </div>

        <div className="form-group">
          <label>Capacity</label>
          <input
            type="number"
            min="0"
            placeholder="e.g. 80"
            value={form.capacity}
            onChange={(e) => setForm({ ...form, capacity: e.target.value })}
          />
        </div>

        <div className="form-group" style={{ gridColumn: 'span 2' }}>
          <label>Description</label>
          <textarea
            rows="4"
            placeholder="Event summary and agenda"
            value={form.description}
            onChange={(e) => setForm({ ...form, description: e.target.value })}
          />
        </div>

        <div className="btn-actions-container" style={{ gridColumn: 'span 2', justifyContent: 'flex-end' }}>
          {editingId && (
            <button
              type="button"
              onClick={() => {
                setEditingId(null);
                setForm(initialFormState);
              }}
              className="btn btn-cancel"
            >
              Cancel
            </button>
          )}
          <button type="submit" className="btn btn-submit-professionals">
            {editingId ? 'Update Event' : 'Add Event'}
          </button>
        </div>
      </form>

      <div className="admin-table-section">
        <DataTable columns={columns} data={events} onEdit={handleEdit} onDelete={handleDelete} />
      </div>
    </div>
  );
}
